var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [(item.redirect === "noredirect" || index == _vm.levelList.length - 1) ? _c('span', {
      staticClass: "no-redirect"
    }, [_vm._v(_vm._s(item.name))]) : _c('router-link', {
      attrs: {
        "to": item.redirect || item.path
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ad20e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Levelbar.vue
// module id = X3tB
// module chunks = 49